/* eslint-disable import/prefer-default-export */

export const getUniqueImageFileName = (name: string): string => {
  const nameArr: string[] = name.replace(/[/\\?%*:|"<>]/g, '').split('.');
  const typeIndex = nameArr.length - 1;
  const type = nameArr[typeIndex];

  nameArr[typeIndex] = `_${new Date().getTime()}`;

  nameArr.push(`.${type}`);

  let newName = '';

  nameArr.forEach((item) => {
    newName += item;
  });

  return newName;
};

export const getShortName = (
  firstName: string | undefined,
  lastName: string | undefined,
  returnFullName = false
): string => {
  const first = firstName || '';
  // const last = lastName && returnFullName ? lastName.substring(0, 1) : '';
  let last = lastName || '';
  if (!returnFullName) {
    last = last.substring(0, 1);
  }
  return `${first} ${last}`;
};
